import { render, staticRenderFns } from "./_horizontal.vue?vue&type=template&id=3f3da475&"
import script from "./_horizontal.vue?vue&type=script&lang=js&"
export * from "./_horizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports